import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal } from "@/components/common";
import styles from "./AddChecklistItemModal.module.css";
export const AddChecklistItemModal = ({ isOpen, onClose, onAdd, }) => {
    const [itemText, setItemText] = useState("");
    // Reset input when modal opens/closes
    useEffect(() => {
        if (!isOpen) {
            setItemText("");
        }
    }, [isOpen]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (itemText.trim()) {
            onAdd(itemText.trim());
            setItemText("");
            onClose();
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && itemText.trim()) {
            handleSubmit(e);
        }
    };
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, children: _jsx("form", { onSubmit: handleSubmit, children: _jsxs("div", { className: styles.modalWrapper, children: [_jsx("div", { className: styles.modalHeader, children: _jsx("h2", { className: styles.modalTitle, children: "Add Checklist Item" }) }), _jsx("div", { className: styles.modalBody, children: _jsxs("div", { className: `${styles.formGroup}`, children: [_jsx("label", { className: styles.formLabel, children: "Item Text" }), _jsx("input", { type: "text", className: styles.textInput, value: itemText, onChange: (e) => setItemText(e.target.value), onKeyDown: handleKeyDown, autoFocus: true })] }) }), _jsxs("div", { className: styles.modalFooter, children: [_jsx("button", { type: "button", className: styles.cancelBtn, onClick: onClose, children: "Cancel" }), _jsx("button", { type: "submit", className: styles.addBtn, disabled: !itemText.trim(), children: "Add Item" })] })] }) }) }));
};
